'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/ui/Button';
import { cn } from '@/hooks/utils';
import { ROUTES, DEMO_LINK } from '@/constants';
import { Locale } from '@/lib/i18n';
import { useEnv } from '../providers/EnvProvider';
interface MobileMenuProps {
  lang: Locale;
  dict: any;
  navLinks: Array<{
    name: string;
    href: string;
  }>;
  isDark?: boolean;
}
export function MobileMenu(t0) {
  const $ = _c(54);
  const {
    dict,
    navLinks,
    isDark: t1
  } = t0;
  const isDark = t1 === undefined ? true : t1;
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();
  useEnv();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(_temp);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const toggleMenu = t2;
  let t3;
  if ($[1] !== pathname) {
    t3 = (e, href) => {
      setIsOpen(false);
      const normalizedPathname = pathname?.replace(/\/$/, "") || "";
      const normalizedHref = href.replace(/\/$/, "");
      if (normalizedPathname === normalizedHref) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    $[1] = pathname;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleLinkClick = t3;
  let t4;
  let t5;
  if ($[3] !== isOpen) {
    t4 = () => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "unset";
        document.documentElement.style.overflow = "unset";
      }
      return _temp2;
    };
    t5 = [isOpen];
    $[3] = isOpen;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  React.useEffect(t4, t5);
  const t6 = isDark ? "bg-white" : "bg-[#0B0623]";
  const t7 = isOpen ? "translate-y-2 rotate-45 bg-white" : "";
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = cn("h-0.5 w-6 transition-all duration-300", t6, t7);
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <span className={t8} />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = isDark ? "bg-white" : "bg-[#0B0623]";
  const t11 = isOpen ? "opacity-0" : "";
  let t12;
  if ($[11] !== t10 || $[12] !== t11) {
    t12 = cn("h-0.5 w-6 transition-all duration-300", t10, t11);
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12) {
    t13 = <span className={t12} />;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = isDark ? "bg-white" : "bg-[#0B0623]";
  const t15 = isOpen ? "-translate-y-2 -rotate-45 bg-white" : "";
  let t16;
  if ($[16] !== t14 || $[17] !== t15) {
    t16 = cn("h-0.5 w-6 transition-all duration-300", t14, t15);
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t16) {
    t17 = <span className={t16} />;
    $[19] = t16;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t13 || $[22] !== t17 || $[23] !== t9) {
    t18 = <button onClick={toggleMenu} className="relative z-50 flex flex-col items-center justify-center gap-1.5 p-2 focus:outline-none" aria-label="Toggle Menu">{t9}{t13}{t17}</button>;
    $[21] = t13;
    $[22] = t17;
    $[23] = t9;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== isOpen) {
    t19 = isOpen && <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" onClick={() => setIsOpen(false)} />;
    $[25] = isOpen;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  const t20 = isOpen ? "translate-x-0" : "translate-x-full";
  let t21;
  if ($[27] !== t20) {
    t21 = cn("fixed inset-y-0 right-0 z-40 min-h-screen w-full max-w-sm transform border-l border-white/10 bg-black p-6 pt-24 transition-transform duration-300 ease-in-out sm:w-[80%]", t20);
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== handleLinkClick || $[30] !== navLinks || $[31] !== pathname) {
    let t23;
    if ($[33] !== handleLinkClick || $[34] !== pathname) {
      t23 = link => <Link key={link.href} href={link.href} onClick={e_0 => handleLinkClick(e_0, link.href)} className={cn("text-lg font-sans font-medium transition-colors hover:text-white/80", pathname === link.href ? "text-white" : "text-white/60")}>{link.name}</Link>;
      $[33] = handleLinkClick;
      $[34] = pathname;
      $[35] = t23;
    } else {
      t23 = $[35];
    }
    t22 = navLinks.map(t23);
    $[29] = handleLinkClick;
    $[30] = navLinks;
    $[31] = pathname;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <hr className="border-white/10" />;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  const t24 = dict.common.practiceLogin || "Practice Login";
  let t25;
  if ($[37] !== t24) {
    t25 = <Button variant="outline" href="https://app.berrystudio.ai/practice/login" target="_blank" rel="noopener noreferrer" className="w-full justify-center">{t24}</Button>;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== dict.common.bookDemo) {
    t26 = <Button variant="primary" href="https://calendar.app.google/trLaKqeFPZJVXGez9" target="_blank" rel="noopener noreferrer" className="w-full justify-center">{dict.common.bookDemo}</Button>;
    $[39] = dict.common.bookDemo;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t25 || $[42] !== t26) {
    t27 = <div className="flex flex-col gap-4">{t25}{t26}</div>;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t22 || $[45] !== t27) {
    t28 = <div className="flex flex-col gap-6">{t22}{t23}{t27}</div>;
    $[44] = t22;
    $[45] = t27;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== t21 || $[48] !== t28) {
    t29 = <div className={t21}>{t28}</div>;
    $[47] = t21;
    $[48] = t28;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== t18 || $[51] !== t19 || $[52] !== t29) {
    t30 = <div className="md:hidden">{t18}{t19}{t29}</div>;
    $[50] = t18;
    $[51] = t19;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  return t30;
}
function _temp2() {
  document.body.style.overflow = "unset";
  document.documentElement.style.overflow = "unset";
}
function _temp(prev) {
  return !prev;
}